import { render, staticRenderFns } from "./CreatePlusBaseTemplatePage.vue?vue&type=template&id=aee9e3d8&scoped=true&"
import script from "./CreatePlusBaseTemplatePage.vue?vue&type=script&lang=js&"
export * from "./CreatePlusBaseTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee9e3d8",
  null
  
)

export default component.exports